import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Laptop, ArrowRight } from "lucide-react";

const MAC_SERVICES = [
  { model: "MacBook Pro/Air", service: "Écran, batterie, clavier", price: "À partir de 155€" },
  { model: "MacBook Pro/Air", service: "Upgrade SSD, RAM", price: "À partir de 119€" },
  { model: "iMac", service: "Diagnostic, réparation", price: "Sur devis" },
  { model: "Tous Mac", service: "Récupération de données", price: "À partir de 95€" },
];

export const MacSection = () => (
  <section className="section-padding bg-slate-900 text-white">
    <div className="container-custom">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Badge className="bg-white/10 text-white border border-white/20 px-4 py-2 mb-6 hover:bg-white/10">
            <Laptop className="w-4 h-4 mr-2" />
            Réparation Mac
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">MacBook & iMac</h2>
          <p className="text-lg text-slate-300 mb-8">
            Nos techniciens certifiés prennent en charge tous vos Mac :
            <strong className="text-white"> diagnostic, réparation, upgrade</strong> et maintenance.
            Main d&apos;œuvre horaire : <strong className="text-white">79 €/h</strong>.
          </p>

          <div className="space-y-4">
            {MAC_SERVICES.map((service) => (
              <div key={`${service.model}-${service.service}`} className="flex items-center justify-between p-4 bg-white/5 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                <div>
                  <p className="font-semibold text-white">{service.model}</p>
                  <p className="text-slate-400 text-sm">{service.service}</p>
                </div>
                <span className="text-red-400 font-semibold">{service.price}</span>
              </div>
            ))}
          </div>

          <Link to="/contact" className="block mt-8">
            <Button size="lg" className="bg-red-600 hover:bg-red-700 gap-2">
              Demander un devis Mac
              <ArrowRight className="h-5 w-5" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-4">
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?w=400" alt="Réparation MacBook" className="w-full h-48 object-cover" loading="lazy" width="400" height="192" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f?w=400" alt="Technicien réparation Mac" className="w-full h-32 object-cover" loading="lazy" width="400" height="128" />
            </div>
          </div>
          <div className="space-y-4 pt-8">
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1560195307-95127677e806?w=400" alt="Réparation iMac" className="w-full h-32 object-cover" loading="lazy" width="400" height="128" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1631452090710-f3914f393618?w=400" alt="iMac 24 pouces" className="w-full h-48 object-cover" loading="lazy" width="400" height="192" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
